export default __webpack_public_path__ + "img/pin_icons/cooling_towers_b.png";